module.exports = __webpack_public_path__ + "b45879fc01f45c7db10c88f0c2c2b2ea.fbx";